export const BASELINECSS_MATERIALUI = "materialui"
export const BASELINECSS_CUSTOM = "custom"
export const REPLACE_USERNAME = "<username>"

export const HIDE_LINKS_FOR_NEXT_INTERNATIONAL = ["Sitemap", "WhoareNext", "NextFranchise"]
export const NEXT_REALM = "next"
export const COUNTRY_GB = "gb"

export const SITE_URL_HEADER = "x-next-siteurl"
export const REALM_HEADER = "x-next-realm"
export const TERRITORY_HEADER = "x-next-territory"
export const LANGUAGE_HEADER = "x-next-language"

export const REPLACE_YEAR = "<yyyy>"

export const VARIANT_DEFAULT = "default"

export const COUNTRY_SELECT_TITLE = "Shop By Country"

export const SUPPORTED_LINK_TYPES = {
    userConsentLink: "UserConsentLink",
}
export const UCM_CLASS = "ot-sdk-show-settings"
export const RESPONSIVE_PAGE_ATTRIBUTE = "data-tp-page"
export const FOOTER_MFE_ID = "epm_footer"

export const DEPENDENCIES_PRELOADJSSVENDOR = "preloadjssvendor"
export const DEPENDENCIES_PRELOADVENDOR = "preloadvendor"
export const DEPENDENCIES_BUNDLEVENDOR = "bundlevendor"
export const DEPENDENCIES_BUNDLE = "bundle"
export const DEPENDENCIES_PRELOAD = "preload"

export const DEFAULT_TEMPLATE = "standard"

export const LOADABLE_NAMESPACE = "FTR"
export const DEV_ESI_HEADER = "test-with-local-esi"

export const SUPPORTED_MY_ACCOUNT_TYPES = Object.freeze({
    loggedIn: "MyAccountLoggedIn",
    loggedOut: "MyAccountLoggedOut",
})

export const XXL_BREAKPOINT_MAX = 1840
export const FOOTER_UI_CACHE_TAG = "footer-ui"
